// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__LOrKA","left":"InfoRow_left__3d0p9"};